module.exports = __webpack_public_path__ + "static/media/integratedshelfv2.f139b4c2.png";